<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="parttitle"><a id="page_1"></a><i>The</i> Vital Spark</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012_Part01.vue?05ffd588